import { RouteSequenceApiV4Interface } from '@/types/api-types';

export const sortApiRouteOptions = (options: RouteSequenceApiV4Interface[]): RouteSequenceApiV4Interface[] => {
  return options.sort((a, b) => {
    // Apply 1.25x penalty for routes with transfers (penalty per transfer)
    const aDurationWithPenalty =
      a.totalDurationSeconds + (a.numTransfers > 0 ? a.totalDurationSeconds * (a.numTransfers * 1.25) : 0);
    const bDurationWithPenalty =
      b.totalDurationSeconds + (b.numTransfers > 0 ? b.totalDurationSeconds * (b.numTransfers * 1.25) : 0);
    return aDurationWithPenalty - bDurationWithPenalty;
  });
};
